export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/settings/applications', 'service-provider.applications')
    .when('/service-provider/settings/applications/marketplace', 'service-provider.marketplace')
    .when('/service-provider/settings/applications/:id', 'service-provider.application-details')
    .when('/service-provider/settings/applications/:id/installed', 'service-provider.view-application')

    .within('service-provider')

    .segment('applications', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.applications'
      }],
      template: '<service-provider-installed-applications-page></service-provider-installed-applications-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-installed-applications.module" */ "./installed/service-provider-installed-applications.module");
      }
    })
    .segment('marketplace', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.applications',
          url: '/service-provider/settings/applications'
        },
        {
          label: 'service_provider.breadcrumb.application_marketplace',
        },
      ],
      template: '<service-provider-applications-marketplace-page></service-provider-applications-marketplace-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-applications-marketplace.module" */ "./marketplace/service-provider-applications-marketplace.module");
      }
    })
    .segment('application-details', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.applications',
          url: '/service-provider/settings/applications'
        },
        {
          label: 'service_provider.breadcrumb.application_marketplace',
          url: '/service-provider/settings/applications/marketplace'
        },
        {
          label: 'service_provider.breadcrumb.application_details'
        }
      ],
      template: '<service-provider-application-details-page></service-provider-application-details-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-application-details.module" */ "./details/service-provider-application-details.module");
      }
    })
    .segment('view-application', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.applications',
          url: '/service-provider/settings/applications'
        },
        {
          label: 'service_provider.breadcrumb.application_details'
        }
      ],
      template: '<service-provider-application-view-page></service-provider-application-view-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-application-view.module" */ "./view/service-provider-application-view.module");
      }
    });

}
